export default __webpack_public_path__ + "static/media/noa-50.3134de69.jpg";